module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/52886015226b693acd9c15e33d924075.svg";